import { z } from 'zod';

const KATAKANA_REGEX = /^[ァ-ヶｦ-ﾟー 　]+$/u;

export const townEditFormSchema = z.object({
  name: z
    .string()
    .trim()
    .min(1, '名前は必須です。')
    .max(255, '名前は255文字以下にしてください。'),
  kana: z
    .string()
    .trim()
    .min(1, '名前カナは必須です。')
    .max(255, '名前カナは255文字以下にしてください。')
    .refine(v => KATAKANA_REGEX.test(v), '名前カナの書式が正しくありません。'),
  postal_code1: z
    .string()
    .trim()
    .min(1, '郵便番号1は必須です。')
    .refine(v => /^\d{3}$/.test(v), '郵便番号1は3桁にしてください。'),
  postal_code2: z
    .string()
    .trim()
    .min(1, '郵便番号2は必須です。')
    .refine(v => /^\d{4}$/.test(v), '郵便番号2は4桁にしてください。'),
  search_name: z
    .string()
    .trim()
    .min(1, '検索名は必須です。')
    .max(255, '検索名は255文字以下にしてください。'),
});

export type TownEditFormData = z.infer<typeof townEditFormSchema>;
